import { includes } from 'lodash';

const DY_LAYOUT_TYPES = ['Outdoor'];

export const shouldDisplayProductsSourceDropdown = (layoutType?: string) =>
  includes(DY_LAYOUT_TYPES, layoutType);
